
import {ShCompanySearch} from 'components/search-dropdown'

export default {
  components: {ShCompanySearch},
  emits: ['submit'],
  data() {
    return {
      prev: undefined,
      id: undefined,
      first_name: '',
      first_name_valid: false,
      last_name: '',
      last_name_valid: false,
      middle_name: '',
      middle_name_valid: false,
      position: '',
      position_valid: false,
      linkedin_id: '',
      linkedin_id_valid: false,
      shared_company_id: undefined,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return this.first_name_valid && this.last_name_valid && this.middle_name_valid && this.linkedin_id_valid && this.position_valid 
    }
  },
  methods: {
    open(data) {
      const {id, first_name, last_name, middle_name, position, linkedin_id, shared_company_id} = data
      this.id = id
      this.first_name = first_name
      this.last_name = last_name
      this.middle_name = middle_name
      this.position = position
      this.linkedin_id = linkedin_id
      this.shared_company_id = shared_company_id
      this.prev = data
      this.loading = false
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.f_name.focus())
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        id: this.id,
        first_name: this.first_name,
        last_name: this.last_name,
        middle_name: this.getFieldValue('middle_name'),
        position: this.getFieldValue('position'),
        linkedin_id: this.linkedin_id,
        shared_company_id: this.getFieldValue('shared_company_id'),
      })
    },
    getFieldValue(key) {
      const prev = this.prev[key]
      const current = this[key]
      if ([null, undefined, ''].includes(prev)) {
        return [null, undefined, ''].includes(current) ? prev : current
      }
      if (current === '' || current === undefined) {
        return null
      }

      return current
    }
  }
}
